import FillRate from 'components/FillRate/FillRate';
import FillRatePanel from 'components/FillRatePanel/FillRatePanel';

import React, { Component } from 'react'
import { Grid, Container, Segment } from 'semantic-ui-react';
import './AccountsDashboardContainer.less';

const OPEN_FILL_RATE = "OPEN_FILL_RATE"
const OPEN_SUBSCRIPTION_REVENUE = "OPEN_SUBSCRIPTION_REVENUE"
const OPEN_COMMISSION_REVENUE = "OPEN_COMMISSION_REVENUE"
const OPEN_ACTUAL_REVENUE = "OPEN_ACTUAL_REVENUE"


const initialStates = {
    openedPanel: undefined,
    fillRateFilterDataToShow: '',
    subscriptionRevenueFilterDataToShow: '',
    commissionRevenueFilterDataToShow: "",
    actualRevenueFilterDataToShow: "",
    fillRatesLastDays: 0,
    commissionRevenueLastMonths: 6,
    actualRevenueLastMonths: 6,
    refreshFillRateData: 0,
    fillRateMapDataToShow: "",
    fillRateMapDataModalIsOpen: false,
    fillRateSelectedFilters: { market: {}, category: {} }
}

class AccountsDashboardContainer extends Component {


    constructor(props) {
        super(props);
        this.state = initialStates;
    }

    openPanelHandler = (panelName) => {
        this.setState({ openedPanel: panelName })
    }
    fillRateFilterDataToShowHandler = (filterType) => {
        this.setState({
            fillRateFilterDataToShow: filterType, subscriptionRevenueFilterDataToShow: "", commissionRevenueFilterDataToShow: "", actualRevenueFilterDataToShow: ""
        })
    }
    subscriptionRevenueFilterDataToShowHandler = (filterType) => {
        this.setState({
            subscriptionRevenueFilterDataToShow: filterType, fillRateFilterDataToShow: "", commissionRevenueFilterDataToShow: "", actualRevenueFilterDataToShow: ""
        })
    }
    commissionRevenueFilterDataToShowHandler = (filterType) => {
        this.setState({
            commissionRevenueFilterDataToShow: filterType, subscriptionRevenueFilterDataToShow: "", fillRateFilterDataToShow: "", actualRevenueFilterDataToShow: ""
        })
    }
    actualRevenueFilterDataToShowHandler = (filterType) => {
        this.setState({
            actualRevenueFilterDataToShow: filterType, commissionRevenueFilterDataToShow: "", subscriptionRevenueFilterDataToShow: "", fillRateFilterDataToShow: ""
        })
    }

    commissionRevenueLastMonthsHandler = (value) => {
        this.setState({ commissionRevenueLastMonths: value })
    }

    fillRateLastDaysHandler = (value) => {
        this.setState({ fillRatesLastDays: value })
    }

    actualRevenueLastMonthsHandler = (value) => {
        this.setState({ actualRevenueLastMonths: value })
    }

    handleFillRateRefresh = () => {
        this.setState({ refreshFillRateData: this.state.refreshFillRateData + 1 })
    }

    handleFillRateMapDataToShow = (fillRateMapDataToShow) => {
        this.setState({ fillRateMapDataToShow: fillRateMapDataToShow })
    }
    handleFillRateMapModalOpen = (isOpen) => {
        this.setState({ fillRateMapDataModalIsOpen: isOpen })
    }
    handleFillRateMapModalClose = () => {
        this.setState({ fillRateMapDataModalIsOpen: false })
    }
    handleFillRateSelectedFilters = (filterName, filterValue) => {
        this.setState({ fillRateSelectedFilters: { ...this.state.fillRateSelectedFilters, [filterName]: filterValue } })
    }

    render() {
        return (
            <Container fluid className={"dashboard-container"}>
                <Segment>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                <FillRate handleFillRateMapModalOpen={this.handleFillRateMapModalOpen} handleFillRateMapDataToShow={this.handleFillRateMapDataToShow} handleFillRateRefresh={this.handleFillRateRefresh} filterDataToShowHandler={this.fillRateFilterDataToShowHandler} filterDataToShow={this.state.fillRateFilterDataToShow} openPanel={() => { this.openPanelHandler(OPEN_FILL_RATE) }} lastDays={this.state.fillRatesLastDays} fillRateLastDaysHandler={this.fillRateLastDaysHandler}> </FillRate>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                {
                                    this.state.openedPanel == OPEN_FILL_RATE
                                    &&
                                    <div>
                                        <FillRatePanel handleFillRateSelectedFilters={this.handleFillRateSelectedFilters} handleFillRateMapModalOpen={this.handleFillRateMapModalOpen} handleFillRateMapDataToShow={this.handleFillRateMapDataToShow} refreshData={this.state.refreshFillRateData} lastDays={this.state.fillRatesLastDays} key={"fill-rate-panel-key"} fillRateFilterDataToShow={this.state.fillRateFilterDataToShow}></FillRatePanel>
                                    </div>
                                }
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Segment>
            </Container>
        )
    }
}

export default AccountsDashboardContainer
